module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cd-wrapper",
    class: {
      play: _vm.play, paused: !_vm.play
    }
  }, [_c('div', {
    staticClass: "cd",
    class: {
      rotatePlay: true, rotatePaused: !_vm.play
    }
  }, [_c('div', {
    staticClass: "cd-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.songDetail.pic_radio,
      "alt": ""
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-5ff060a9"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/cd/cd.vue
// module id = 208
// module chunks = 1